export const ADD = "cart/add";
export const DECREASE = "cart/decrease";
export const REMOVE = "cart/remove";


